import React from 'react';

// ─── SVG Icon component ───
export const ICONS = {
  search: <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></>,
  filter: <><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></>,
  heart: <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>,
  x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
  check: <><polyline points="20 6 9 17 4 12"/></>,
  download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
  bell: <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>,
  map: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>,
  home: <><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
  ai: <><path d="M12 2L2 7l10 5 10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></>,
  chart: <><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>,
  file: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></>,
  user: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
  grid: <><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></>,
  list: <><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/></>,
  back: <><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></>,
  tag: <><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></>,
  shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
  sun: <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></>,
  moon: <><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></>,
  calc: <><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/></>,
};

export function Ic({ name, s = 18, c = 'currentColor' }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none"
      stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {ICONS[name]}
    </svg>
  );
}

export function HeartFilled({ s = 16 }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="#ef4444" stroke="#ef4444" strokeWidth="2">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

// ─── Badge ───
export function Badge({ children, variant = 'default' }) {
  const styles = {
    default: { bg: 'var(--s2)', color: 'var(--t2)', border: 'var(--s3)' },
    green:   { bg: 'var(--gl)', color: 'var(--gn)', border: 'rgba(22,163,74,.2)' },
    orange:  { bg: 'var(--ol)', color: 'var(--or)', border: 'rgba(194,65,12,.2)' },
    red:     { bg: 'var(--rl)', color: 'var(--rd)', border: 'rgba(220,38,38,.2)' },
    brand:   { bg: 'var(--bb)', color: 'var(--br)', border: 'rgba(184,134,42,.25)' },
  };
  const s = styles[variant] || styles.default;
  return (
    <span style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}`, padding: '2px 8px', borderRadius: 5, fontSize: 10, fontWeight: 700, whiteSpace: 'nowrap', letterSpacing: '.4px', textTransform: 'uppercase' }}>
      {children}
    </span>
  );
}

// ─── Modal overlay ───
export function Modal({ children, onClose, maxWidth = 540 }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--ov)', backdropFilter: 'blur(12px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1500, padding: 12 }} onClick={onClose}>
      <div className="modal-inner modal-glass" onClick={(e) => e.stopPropagation()} style={{ background: 'var(--sf)', borderRadius: 20, padding: 28, maxWidth, width: '100%', maxHeight: '88vh', overflowY: 'auto', border: '1px solid var(--bd)', boxShadow: 'var(--shadow-lg)', animation: 'slideUp .3s ease' }}>
        {children}
      </div>
    </div>
  );
}

// ─── Modal header ───
export function ModalHeader({ title, onClose, icon }) {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8, color: 'var(--tx)', letterSpacing: '-.2px' }}>
          {icon} {title}
        </h2>
        <button onClick={onClose} style={{ background: 'var(--s2)', border: '1px solid var(--bd)', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background .15s' }}>
          <Ic name="x" s={13} c="var(--t3)" />
        </button>
      </div>
      <hr className="gold-divider" style={{ marginBottom: 20 }} />
    </>
  );
}

// ─── Common input style ───
export const inputStyle = {
  width: '100%',
  padding: '9px 11px',
  borderRadius: 8,
  border: '1px solid var(--bd)',
  background: 'var(--sf)',
  fontSize: 13,
  color: 'var(--tx)',
  boxSizing: 'border-box',
  fontFamily: 'var(--font-ui)',
  transition: 'border-color .2s, box-shadow .2s',
};

// ─── Button styles for better accessibility ───
export const primaryButtonStyle = {
  padding: '10px 16px',
  borderRadius: 8,
  border: 'none',
  background: 'var(--br)',
  color: '#fff',
  fontWeight: 600,
  fontSize: 14,
  cursor: 'pointer',
  transition: 'background .15s, box-shadow .15s',
  outline: 'none',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
};

export const secondaryButtonStyle = {
  padding: '10px 16px',
  borderRadius: 8,
  border: '1px solid var(--bd)',
  background: 'var(--sf)',
  color: 'var(--tx)',
  fontWeight: 600,
  fontSize: 14,
  cursor: 'pointer',
  transition: 'border-color .15s, color .15s, box-shadow .15s',
  outline: 'none',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
};

export const ghostButtonStyle = {
  padding: '10px 16px',
  borderRadius: 8,
  border: 'none',
  background: 'transparent',
  color: 'var(--br)',
  fontWeight: 600,
  fontSize: 14,
  cursor: 'pointer',
  transition: 'color .15s, background .15s, box-shadow .15s',
  outline: 'none',
};
